module.exports = __webpack_public_path__ + "img/br4.92753e2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/br4.jpg
// module id = brSh
// module chunks = 0